import { SelectList } from 'complex-data'
import { SelectListValueType } from 'complex-data/src/data/SelectList'
import selectApi from '../api/select'
import selectLoad from './load'
import { LoadControlItemInitOption } from '@/class/LoadControl'

const configKeys = [
  'business_lines_green',
  'ASSIGN_TYPE',
  'DAY_NUM',
  'GuaranteeType',
  'CASE_COLLECTION_TYPE',
  'BONDSMAN_STATUS',
  'WAY_OF_SIGNING',
  'family_relative_guarantee',
  'SEND_TYPE',
  'CollectionRecordRiskType',
  'familyrelative',
  'CollectionRecordOverReason',
  'CollectionRecordCollectionResult',
  'relation_type',
  'CertType',
  'sex',
  'marry',
  'leas_form',
  'business_lines',
  'business_types',
  'area',
  'FLOW_END_REASON',
  'LITIGATION_TYPE',
  'LITIGATION_REQUEST_TYPE',
  'litigationJudgmentResultType',
  'litigationJudgmentExecutionPlanType',
  'closeCaseReasonType',
  'litigationCollectionContentType',
  'litigationCollectionMethodType',
  'LitigationExecuteUnsealReason',
  'LitigationExecuteUnsealContent',
  'LitigationSeizeUnsealReason',
  'LitigationSeizeUnsealContent',
] as const

type dictKeys = typeof configKeys[number]

export const dict: Record<dictKeys, SelectList<SelectListValueType<string>>> = {} as Record<dictKeys, SelectList<SelectListValueType<string>>>

export const loadDictData = function(): Promise<{ status: string, data: Record<string, SelectListValueType<string>[]> }> {
  return new Promise((resolve, reject) => {
    selectApi.dict.require(configKeys as unknown as string[]).then((res) => {
      const dictData: Record<string, SelectListValueType<string>[]> = {}
      for (const key in res.data.data) {
        dictData[key] = res.data.data[key].map(item => {
          return {
            value: item.key,
            label: item.value
          }
        })
      }
      resolve({ status: 'success', data: dictData })
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error(err)
      reject(err)
    })
  })
}

export const loadDict = function() {
  return selectLoad.pushControl('dict', {
    offset: 80 * 1000,
    priority: 1,
    local: 'dict',
    check (localData) {
      if (localData) {
        const localKeys = Object.keys(localData)
        if (localKeys.length === configKeys.length) {
          for (let i = 0; i < configKeys.length; i++) {
            const key = configKeys[i]
            if (localKeys.indexOf(key) === -1) {
              return
            }
          }
          return true
        }
      }
    },
    load() {
      return loadDictData()
    },
    init(initData) {
      for (const key in initData) {
        dict[key as dictKeys] = new SelectList({
          name: key,
          prop: key,
          list: initData[key as dictKeys]
        })
      }
    }
  } as LoadControlItemInitOption<Record<string, SelectListValueType<string>[]>>)
}
